'use client';

import { useAuthActions } from '@convex-dev/auth/react';
import { useState } from 'react';

export function SignInForm() {
  const { signIn } = useAuthActions();
  const [flow, setFlow] = useState<'signIn' | 'signUp'>('signIn');
  const [error, setError] = useState<string | null>(null);
  const [isLoading, setIsLoading] = useState(false);

  const handleAnonymousSignIn = async () => {
    setIsLoading(true);
    setError(null);
    try {
      await signIn('anonymous');
    } catch (error) {
      setError((error as Error).message);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="flex flex-col gap-8 w-96 mx-auto">
      <p>Log in to see the numbers</p>
      <form
        className="flex flex-col gap-2"
        onSubmit={(e) => {
          e.preventDefault();
          const formData = new FormData(e.target as HTMLFormElement);
          formData.set('flow', flow);
          void signIn('password', formData).catch((error) => {
            setError(error.message);
          });
        }}
      >
        <input
          className="bg-light dark:bg-dark text-dark dark:text-light rounded-md p-2 border-2 border-slate-200 dark:border-slate-800"
          type="email"
          name="email"
          placeholder="Email"
        />
        <input
          className="bg-light dark:bg-dark text-dark dark:text-light rounded-md p-2 border-2 border-slate-200 dark:border-slate-800"
          type="password"
          name="password"
          placeholder="Password"
        />
        <button
          className="bg-dark dark:bg-light text-light dark:text-dark rounded-md"
          type="submit"
        >
          {flow === 'signIn' ? 'Sign in' : 'Sign up'}
        </button>
        <div className="flex flex-row gap-2">
          <span>
            {flow === 'signIn'
              ? "Don't have an account?"
              : 'Already have an account?'}
          </span>
          <span
            className="text-dark dark:text-light underline hover:no-underline cursor-pointer"
            onClick={() => setFlow(flow === 'signIn' ? 'signUp' : 'signIn')}
          >
            {flow === 'signIn' ? 'Sign up instead' : 'Sign in instead'}
          </span>
        </div>
        {error && (
          <div className="bg-red-500/20 border-2 border-red-500/50 rounded-md p-2">
            <p className="text-dark dark:text-light font-mono text-xs">
              Error signing in: {error}
            </p>
          </div>
        )}
      </form>
      
      <div className="flex items-center gap-4">
        <hr className="flex-1 border-slate-300 dark:border-slate-700" />
        <span className="text-sm text-slate-500 dark:text-slate-400">or</span>
        <hr className="flex-1 border-slate-300 dark:border-slate-700" />
      </div>
      
      <button
        className="bg-slate-200 dark:bg-slate-800 text-dark dark:text-light rounded-md p-2 hover:bg-slate-300 dark:hover:bg-slate-700 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
        onClick={() => void handleAnonymousSignIn()}
        disabled={isLoading}
        type="button"
      >
        {isLoading ? 'Signing in...' : 'Continue as Guest'}
      </button>
    </div>
  );
}
